import {
  request
} from '@/utils/request.js'


const getPlayers = (data, callback, errCallback, finCallback) => {
  request({
    url: '/player/players',
    method: 'GET',
    params: data,
    success: callback,
    fail: errCallback,
    complete: finCallback
  })
}

const getOwnerPlayers = (data, callback, errCallback, finCallback) => {
  request({
    url: '/player/owner',
    method: 'GET',
    params: data,
    success: callback,
    fail: errCallback,
    complete: finCallback
  })
}


const getPlayerById = (playerId, callback, errCallback, finCallback) => {
  request({
    url: `/player/player/${playerId}`,
    method: 'GET',
    success: callback,
    fail: errCallback,
    complete: finCallback
  })
}

const getPointsById = (playerId, data, callback, errCallback, finCallback) => {
  request({
    url: `/player/points/${playerId}`,
    method: 'GET',
    params: data,
    success: callback,
    fail: errCallback,
    complete: finCallback
  })
}

const getResultsById = (status, playerId, data, callback, errCallback, finCallback) => {
  request({
    url: `/player/results/${playerId}/${status}`,
    params: data,
    method: 'GET',
    success: callback,
    fail: errCallback,
    complete: finCallback
  })
}

const getEnOwnerPlayers = (callback, errCallback, finCallback) => {
  request({
    url: `/player/en`,
    method: 'GET',
    success: callback,
    fail: errCallback,
    complete: finCallback
  })
}


export {
  getPlayers,
  getOwnerPlayers,
  getPlayerById,
  getPointsById,
  getResultsById,
  getEnOwnerPlayers
}


// WEBPACK FOOTER //
// ./src/servers/players.js